import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Dashboard } from "../../../types";
import { dashboardService } from "../../../services/dashboardService";

export const useCreateDashboard = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (input: Omit<Dashboard, "id" | "serviceMapId" | "metrics">) =>
      dashboardService.create(input),
    onSuccess: (created) => {
      qc.setQueryData(["dashboard", created.id], created);
      qc.invalidateQueries({
        queryKey: ["dashboards"],
      });
    },
  });
};
